import { PeriodLayout, maximumPreviewPeriods } from "./periodLayout";
import { Stack, TextField } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

export const PeriodHorizonControls = ({
  periodLayout,
  deployable,
  forecast,
  onDeployableChange,
  onForecastChange,
}: {
  periodLayout: PeriodLayout;
  deployable: number;
  forecast: number;
  onDeployableChange: (count: number) => void;
  onForecastChange: (count: number) => void;
}) => {
  const { t } = useTenantTranslation();
  return (
    <Stack direction="row" gap={1} sx={{ flexWrap: "wrap" }}>
      {[
        {
          label:
            periodLayout.forecast.maximum === 0
              ? "autoNumberOfPeriods"
              : "autoDeployablePeriods",
          range: periodLayout.deployable,
          count: deployable,
          onChange: onDeployableChange,
        },
        {
          label: "autoForecastPeriods",
          range: periodLayout.forecast,
          count: forecast,
          onChange: onForecastChange,
        },
      ]
        .filter(({ range }) => range.minimum !== range.maximum)
        .map(({ label, count, onChange, range }) => (
          <TextField
            sx={{ minWidth: 230, flex: 1 }}
            key={label}
            size="small"
            type="number"
            label={t(label)}
            value={count}
            slotProps={{
              htmlInput: {
                min: Math.min(range.minimum, maximumPreviewPeriods),
                max: Math.min(
                  range.maximum ?? maximumPreviewPeriods,
                  maximumPreviewPeriods
                ),
                step: 1,
              },
            }}
            onChange={(event) => {
              const next = Number(event.target.value);
              if (
                Number.isInteger(next) &&
                next >= Math.min(range.minimum, maximumPreviewPeriods) &&
                next <=
                  Math.min(
                    range.maximum ?? maximumPreviewPeriods,
                    maximumPreviewPeriods
                  )
              )
                onChange(next);
            }}
          />
        ))}
    </Stack>
  );
};
